<template>
    <!--    <div class="portfolio-multistep-overview">-->
    <!--        <design-2021-apprentice-multistep-form-wizard-form-header-component title="Overzicht"-->
    <!--                                                                            :description="description">-->
    <!--        </design-2021-apprentice-multistep-form-wizard-form-header-component>-->

    <!--        <div class="overview-content">-->
    <!--            <div class="overview-group project-name-group">-->
    <!--                <h4 class="title">{{ steps[0].title }}</h4>-->
    <!--                {{ formData.project_name }}-->
    <!--            </div>-->

    <!--            <div class="overview-group settings-group">-->
    <!--                <h4 class="title">{{ steps[1].title }}</h4>-->
    <!--                <div class="course-setting">-->
    <!--                    <div class="course">-->
    <!--                        <span class="label">Vak:</span>-->
    <!--                        <span class="text">{{ formData.settings.course.name }}</span>-->
    <!--                    </div>-->

    <!--                    <div class="custom-banner-setting">-->
    <!--                        <span class="label">Aangepaste vak banner:</span>-->
    <!--                        <div class="banner-preview"-->
    <!--                             v-if="formData.settings.banner !== ''">-->
    <!--                            <img :src="getFileUrl()" alt="banner">-->
    <!--                        </div>-->
    <!--                        <span class="text"-->
    <!--                              v-else>-->
    <!--                            Geen aangepaste vak banner-->
    <!--                        </span>-->
    <!--                    </div>-->
    <!--                </div>-->

    <!--                <div class="schoolyear-setting">-->
    <!--                    <div class="season">-->
    <!--                        <span class="label">Schooljaar:</span>-->
    <!--                        <span class="text">{{ formData.settings.season.season }}</span>-->
    <!--                    </div>-->
    <!--                    <div class="start-date">-->
    <!--                        <span class="label">Start datum:</span>-->
    <!--                        <span class="text">{{ formData.settings.start_date | date_named_month}}</span>-->
    <!--                    </div>-->
    <!--                    <div class="end-date">-->
    <!--                        <span class="label">Eind datum:</span>-->
    <!--                        <span class="text">{{ formData.settings.end_date | date_named_month}}</span>-->
    <!--                    </div>-->
    <!--                </div>-->

    <!--                <div class="editor-type">-->
    <!--                    <span class="label">Editor type</span>-->
    <!--                    <span class="text">{{ formData.settings.editor_type.text }}</span>-->
    <!--                </div>-->
    <!--            </div>-->

    <!--            <div class="overview-group coordinates-group">-->
    <!--                <h4 class="title">{{ steps[2].title }}</h4>-->
    <!--                <ul class="teachers-list"-->
    <!--                    v-if="formData.coordinators.length > 0">-->
    <!--                    <li class="teacher"-->
    <!--                        v-for="coordinator in formData.coordinators"-->
    <!--                        :key="coordinator.id">-->
    <!--                        <i class="icon fa-fw fad fa-user"></i>-->
    <!--                        {{coordinator.full_name }}-->
    <!--                    </li>-->
    <!--                </ul>-->

    <!--                <div class="no-teachers-added"-->
    <!--                     v-else>-->
    <!--                    Er zijn geen coördinatoren toegevoegd-->
    <!--                </div>-->
    <!--            </div>-->

    <!--            <div class="overview-group options-group">-->
    <!--                <h4 class="title">{{ steps[3].title }} actief</h4>-->
    <!--                <ul class="options-list"-->
    <!--                    v-if="hasOptionsEnabled()">-->
    <!--                    <li class="option"-->
    <!--                        v-for="option in formData.options"-->
    <!--                        v-if="option.enabled">-->
    <!--                        <i :class="getIconClass(option)"></i>-->
    <!--                        {{ option.label }}-->
    <!--                    </li>-->
    <!--                </ul>-->

    <!--                <div class="no-teachers-added"-->
    <!--                     v-else>-->
    <!--                    Er zijn geen opties actief-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->
    <div>UNUSED!</div>
</template>

<script>
    export default {
        name: 'design-2021-apprentice-portfolio-wizard-overview-step-component',
        props: {
            steps: {
                type: Array,
                required: true,
            },
            formData: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                description:
                    'Controleer het ingevulde data alvorens je het formulier verstuur. Indien nodig gebruik de terug knop om terug te gaan om wijzigingen aan te brengen waar nodig.',
            };
        },

        methods: {
            getFileUrl() {
                const file = this.formData.settings.banner;
                return URL.createObjectURL(file);
            },

            getIconClass(optionType) {
                switch (optionType.key) {
                    case 'calendar':
                        return 'icon fa-fw fad fa-calendar-alt';

                    case 'messages':
                        return 'icon fa-fw fad fa-envelope';
                }
            },

            hasOptionsEnabled() {
                let tally = 0;

                for (const option of this.formData.options) {
                    option.enabled === true && tally++;
                }

                return tally > 0;
            },
        },
    };
</script>

<style scoped lang="scss">
    ul {
        list-style: none;
        padding: 0;
    }

    .overview-group {
        background-color: $secondary-background-color;
        border-radius: $border-radius-content;
        padding: map-get($grid-gutter-spacing, 'fifteen');
        font-size: $base-font-size;
        line-height: 1.5;

        > div > div {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .title {
            border-bottom: 2px solid $border-color;
            padding-bottom: map-get($grid-gutter-spacing, 'eight');
        }

        .label {
            margin-right: map-get($grid-gutter-spacing, 'eihgt');
        }

        &:not(:last-child) {
            margin-bottom: $grid-gutter-width;
        }
    }

    .banner-preview {
        width: 100%;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
    }

    .teacher,
    .option {
        .icon {
            color: var(--primary);
            font-size: $base-font-size;
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }
</style>
